<template>
  <div class="list-modelli">
    <div :class="count_modelli">
      <v-sheet
        class="mx-auto border-solid product-wrapper"
        elevation="0"
        :max-width="maxwidth"
      >
        <v-slide-group
          v-model="model"
          class="v-slide-group__content_photo"
          :class="p4x"
          mandatory
          center-active
          show-arrows
        >
          <v-slide-item
            v-for="list in modelli"
            :key="list.id_prodotto"
            v-slot="{ active, toggle }"
          >
            <v-card
              v-bind:id="list.id_prodotto"
              :color="list.selected ? 'primary' : ''"
              class="content_modelli ma-4 no-shadow no-focus"
              height="360"
              width="220"
              @click="toggle"
            >
              <v-row
                class="fill-height product-list-modello"
                :data="list.modello_var"
                justify="center"
                @click="
                  onCardClick_modello(
                    list.modello_var,
                    list.MODELLO,
                    list,
                    modelli,
                    list.id_prodotto
                  )
                "
              >
                <!--   <VueCustomTooltip                                 -->
                <!--     :label="                                        -->
                <!--       is_italian                                    -->
                <!--         ? (list.MODELLO_NOME_ITA !== undefined      -->
                <!--             ? list.MODELLO_NOME_ITA                 -->
                <!--             : '') +                                 -->
                <!--           ' ' +                                     -->
                <!--           list.MODELLO_ITA                          -->
                <!--         : (list.MODELLO_NOME_ENG !== undefined      -->
                <!--             ? list.MODELLO_NOME_ENG                 -->
                <!--             : '') +                                 -->
                <!--           ' ' +                                     -->
                <!--           list.MODELLO_ENG                          -->
                <!--     "                                               -->
                <!--     position="is-bottom"                            -->
                <!--   >        
                                                    -->
                <label
                  for="file-upload"
                  v-if="logged_in"
                  class="custom-file-upload"
                  :class="list.SELECTED ? 'active_input ' : 'not_active_input'"
                >
                  <i class="fa fa-cloud-upload"></i>
                </label>
                <input
                  id="file-upload"
                  v-if="logged_in"
                  type="file"
                  @change="uploadFile"
                  ref="file"
                  :class="list.SELECTED ? 'active_input ' : 'not_active_input'"
                />
                <p style="display: none">
                  {{ list.COLOREVETRO }} {{ list.SORGENTE }}
                  {{ list.testo_finiturastruttura }}
                </p>

                <img
                  v-bind:src="url + 'risorse/preview/' + select_img(list)"
                  :class="
                    list.SELECTED
                      ? 'active_image ' +
                        modelle_class +
                        ' ' +
                        list.id_prodotto +
                        ' ' +
                        select_img(list)
                      : 'not_active_image_j ' +
                        modelle_class +
                        ' ' +
                        list.id_prodotto +
                        ' ' +
                        select_img(list)
                  "
                  onerror="this.src='https://vistosi.it/risorse/preview/IMGNOTFOUND.jpg'"
                  data="dd"
                />
                <!--      onerror=" this.src='https://vistosi.wowtest.it/risorse/preview/IMGNOTFOUND.jpg'" -->

                <!--  
                       -->
                <!--   </VueCustomTooltip> -->

                <p
                  class="no-margin-modelli testo_modelli_photo margin_negativo_30"
                >
                  {{ list.FAMIG_ESTESA }} {{ list.tipologia }}
                  {{ list.MODELLO != "000" && list.MODELLO != "00" ?   list.MODELLO : ""  }}
                  
                  {{ list.modello_var != "0" && list.modello_var != "00" ? list.modello_var : "" }}
                </p>

                <v-scale-transition>
                  <!--  <v-icon
                v-if="active"
                color="black"
                size="50"
                v-text="'mdi-close-circle-outline'"
              ></v-icon> -->
                </v-scale-transition>
              </v-row>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </v-sheet>
    </div>
  </div>
</template>

<script>
import checkLanguage from "../classes/class_check_language";
import is_localhost from "../classes/class_is_localhost";
import filter_array from "../classes/class_filter_arrays";
import logged_in from "../classes/logged_in";

export default {
  name: "modelli",
  data: () => ({
    model: [],
    modelloclass: "",
    modelli: [],
    is_italian: false,
    url: "",
    count_modelli: "modelli_group_count",
    logged_in: false,
    init: true,
  }),
  created() {
    window.addEventListener("resize", this.myEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },

  mounted() {
    let c = new checkLanguage();
    let ur = new is_localhost();
    this.url = ur.return_url_website();
    this.is_italian = c.is_italian();

    this.$store.subscribe((mutation) => {
      console.info("mutation", mutation.type, this.modelli);

         if (mutation.type == "aggiornare_sorgente ") {
          console.info('mutation list_modelli before', this.modelli.length);
          this.myEventHandler();
          console.info('mutation list_modelli after', this.modelli.length);
        }
      if (mutation.type == "logged_in") {
        this.logged_in = true;
      }
      if (mutation.type == "select_product_by_id") {
        let f = new filter_array();
        console.info('filtro_modelli select_product_by_id', this.modelli);
        this.modelli = f.riordina_prezzi2(this.modelli);
        console.info('filtro_modelli select_product_by_id', this.modelli);
        if (!this.esiste_un_modello_selezionato(this.modelli, mutation.type) && this.modelli.length>0) {
          this.modelli = this.select_the_first(this.modelli);
        }

        this.myEventHandler();
        console.info("mutation select_product_by_id after", this.modelli);
      }
      if (mutation.type == "get_modelli_to_display_from_vetro_and_montatura") {
        let f = new filter_array();
        console.info('183 listmodelli', this.$store.state);
        if (
        (  this.$store.state.products.SORGENTE[0].FAMIG_ESTESA == "LIO" &&
          this.$store.state.products.SORGENTE[0].tipologia == "AP" ) || 
          (  this.modelli[0].famiglia == "LUCCI" &&
          this.modelli[0].tipologia == "AP" )
        ) {
          console.log("no");
        } else {
                console.info('filtro_modelli get_modelli_to_display_from_vetro_and_montatura', this.modelli);
          this.modelli = f.riordina_prezzi(this.$store.state);
                     console.info('filtro_modelli get_modelli_to_display_from_vetro_and_montatura', this.modelli);
                console.info("mutation get_modelli_to_display_from_vetro_and_montatura after", this.modelli);
          this.myEventHandler();
          console.info("l2", this.modelli);
        }
        if (this.init) {
          console.info("init true");
          this.init = false;
          if (
         (   this.$store.state.products.SORGENTE[0].FAMIG_ESTESA == "RINA" &&
            this.$store.state.products.SORGENTE[0].tipologia == "SP"
         ) ||

          (   this.$store.state.products.SORGENTE[0].FAMIG_ESTESA == "RINA" &&
            this.$store.state.products.SORGENTE[0].tipologia == "LT"
         ) ||

          (   this.$store.state.products.SORGENTE[0].FAMIG_ESTESA == "LIO" &&
            this.$store.state.products.SORGENTE[0].tipologia == "SP"
         ) || 
          (  this.modelli[0].famiglia == "LUCCI" &&
          this.modelli[0].tipologia == "AP" )
          ) {
            this.$store.commit(
              "click_on_montatura",
              this.modelli[0].testo_finiturastruttura
            );
          } else {
            console.info("init false");
          }
        }
      }
      //aggiorna_sorgente_luminosa
      if (mutation.type == "change_id_prodotto") {
        let f = new filter_array();
                   console.info('filtro_modelli change_id_prodotto', this.modelli);
        this.modelli = f.riordina_prezzi(this.$store.state);
                   console.info('filtro_modelli change_id_prodotto', this.modelli);
        
        this.esiste_un_modello_selezionato(this.modelli, mutation.type);
             console.info("mutation change_id_prodotto after", this.modelli);
        this.$store.commit("search_id_product_by_modello_var", {
          modello_var: this.$store.state.product_store.MODELLO_VAR,
          MODELLO: this.$store.state.product_store.MODELLO,
        });
        this.vetro = this.$store.state.product_store.VETRO;
        this.montatura = this.$store.state.product_store.MONTATURA;
        this.sorgente = this.$store.state.product_store.SORGENTEBIS;
        this.$store.commit("get_modelli_to_display_from_vetro_and_montatura", {
          VETRO: this.vetro,
          MONTATURA: this.montatura,
          MODELLOVAR: this.$store.state.product_store.MODELLO_VAR,
          MODELLO: this.$store.state.product_store.MODELLO,
          SORGENTE: this.sorgente,
        });
        this.myEventHandler();
        console.info("m before cip", this.modelli);
        console.info("l3");
      }

      if (mutation.type == "click_on_vetro") {
        console.info("click on vetro:", this.$store.state.product.vetri_new);
        try {
          let v = this.$store.state.product.vetri_new;
          let vs = v.filter((vetro) => {
            return vetro.SELECTED == true;
          });
          console.info("vetro selected", vs);
          console.info("vetro selected", vs[0].COLOREVETRO);
        } catch (error) {
          console.info(error);
        }

        let f = new filter_array();
                   console.info('filtro_modelli click_on_vetro', this.modelli);
        
        this.modelli = f.riordina_prezzi(this.$store.state);

                   console.info('filtro_modelli click_on_vetro', this.modelli);
        
                    console.info("mutation click_on_vetro after", this.modelli);
        this.$store.commit("search_id_product_by_modello_var", {
          modello_var: this.$store.state.product_store.MODELLO_VAR,
          MODELLO: this.$store.state.product_store.MODELLO,
        });
        this.vetro = this.$store.state.product_store.VETRO;
        this.montatura = this.$store.state.product_store.MONTATURA;
        this.sorgente = this.$store.state.product_store.SORGENTE;
        this.$store.commit("get_modelli_to_display_from_vetro_and_montatura", {
          VETRO: this.vetro,
          MONTATURA: this.montatura,
          MODELLOVAR: this.$store.state.product_store.MODELLO_VAR,
          MODELLO: this.$store.state.product_store.MODELLO,
          SORGENTE: this.sorgente,
        });
        this.myEventHandler();
        console.info("m before cip", this.modelli);
        console.info("l4");
      }
      if (mutation.type == "click_on_montatura") {
        let f = new filter_array();
                   console.info('filtro_modelli click_on_montatura', this.modelli);
        
        this.modelli = f.riordina_prezzi(this.$store.state);
                   console.info('filtro_modelli click_on_montatura', this.modelli);
         this.esiste_un_modello_selezionato(this.modelli, mutation.type);
               console.info("mutation click_on_montatura after", this.modelli);
        this.$store.commit("search_id_product_by_modello_var", {
          modello_var: this.$store.state.product_store.MODELLO_VAR,
          MODELLO: this.$store.state.product_store.MODELLO,
        });

        try {
          let ml = this.modelli.filter((modello) => {
            return modello.SELECTED == true;
          });
          console.info("ml length: ", ml.length);
          if (ml.length == 0) {
            //  this.modelli[0].SELECTED = true;
            //  let modello_var = this.modelli[0].
            this.onCardClick_modello(
              this.modelli[0].modello_var,
              this.modelli[0].MODELLO,
              this.modelli[0],
              this.modelli,
              this.modelli[0].id_prodotto
            );
          }
        } catch (error) {
          console.log(error);
        }

        this.myEventHandler();
        console.info("l5");
      }
    });
    setTimeout(() => {
      this.myEventHandler();
    }, 500);
  },

  computed: {
    maxwidth() {
      try {
        let width = document.getElementById("dfnweio3").offsetWidth;
        return width;
      } catch (error) {
        let width = 800;
        return width;
      }
    },
    p4x() {
      try {
        let pixels = window.innerWidth;
        if (pixels > 630) {
          return " pa-4 ";
        }
        return " mobile ";
      } catch (error) {
        return " pa-4 ";
      }
    },
    modelle_class() {
      let c = this.$store.state.products.SORGENTE.length;
      let modelloclass = "";

      if (c == 1) {
        modelloclass = "one_product_only";
      } else {
        modelloclass = "";
      }
      return modelloclass;
    },

    product() {
      return this.$store.state.products.SORGENTE;
    },
    debug() {
      return this.$store.state.products.debug;
    },
  },
  methods: {
    select_the_first(modelli){
      console.info('select_the_first', modelli);
      console.table(modelli);
      modelli[0].SELECTED = true;
            let codice_univoco = modelli[0].id_prodotto;
            this.$store.commit('select_product_by_id',codice_univoco);
      return modelli;
    },
    esiste_un_modello_selezionato(modelli, mutation){
    let exist = false;    
        let selected_modelli = modelli.filter(
          function (modello){
            return modello.SELECTED == true;
          }
        );
        console.info('lenght selected'+mutation, selected_modelli.length, selected_modelli);
        console.table(selected_modelli);
        
       if (selected_modelli.length > 0) {
        exist = true;
       }
       return exist;
    },


    filter_modelli(modelli) {
      try {
        let t = modelli.filter((modello) => {
          return modello.SELECTED == true;
        });
        console.info(t);
      } catch (error) {
        console.info(error);
      }
    },
    uploadFile(event) {
      console.info(event.target.files[0]);
      this.Images = "";
      console.info(this.$refs);
      console.info(this.$refs.file);

      console.info(this.$refs.file[0]);
      let l = new logged_in();
      l.uploadFile(
        event.target.files[0],
        this.$store.state.product_store.CODICE_UNIVOCO
      ).then((response) => {
        console.log(response);

        setTimeout(() => {
          location.reload();
        }, 1500);
      });
    },
    myEventHandler() {
      try {
        console.info('eventhadler A');
        let width = window.innerWidth;
        let count = this.modelli.length;
        if (count == 1) {
          console.info('eventhadler B');
          this.modelloclass = "one_product_only";
          this.count_modelli = "only_one";
        }

        if (width > 1000 && width < 1920) {
          console.info('eventhadler C');
          if (count <= 2) {
            console.info('eventhadler D');
            this.count_modelli = "only_one";
          }
          setTimeout(() => {
            console.info('eventhadler E');
            let t = document.getElementsByClassName("colonna-img-fissa");
            let inner = t[0].clientWidth;
            let diff = width - inner - 150;
            if (width > 1280) {
              console.info('eventhadler F');
              let height = window.innerHeight;
              console.info("height", height);
              inner = ((height - 103) * 2000) / 1537;
              console.info("inner", inner);
              diff = width - inner;
              console.info("diff", diff);
              let g = Math.floor(diff / 244);
              console.info("g", g);
              diff = g * 244;
              console.info("diff", diff);
              if (g == count) {
                console.info('eventhadler G');
                this.count_modelli = "only_one";
              }
              if (count > g) {
                                console.info('eventhadler H');

                this.count_modelli = "";
              }
            }
            if (width == 1126) {
              console.info('eventhadler I');
              diff = 473;
            }
            if (width <= 1000) {
                            console.info('eventhadler L');

              diff = width * 0.88;
            }
            try {
                  let s = document.getElementsByClassName("v-slide-group__wrapper");
              if (Array.isArray(s)) {
  // myVariable is an array
            s.forEach((element) => {
              console.info(element);
              element.style.minWidth = diff + "px";
              element.style.width = diff + "px";
            });
            
        
}    
} catch (error) {
              console.info(error);
            }
         
          }, 50);
        }

        if (width > 1150) {
          console.info('eventhadler M');
          if (count <= 2) {
            console.info('eventhadler N');
            this.count_modelli = "only_one";
          }else{
            this.count_modelli = "";

          }
        }
      } catch (error) {
        console.info('eventhadler O');
        console.info("error on resize", error);
      }
      // your code for handling resize...
    },

    is_active_image() {},
    product_method() {
      return this.$store.state.products.SORGENTE;
    },

    select_img(list) {
      if (list.tipologia == "PL") {
        if (list.IMG_D == "") {
          return list.IMG_B;
        }
        return list.IMG_D;
      }
      return list.IMG_B;
    },
    // questo metodo modifica la variabile debug

    onCardClick_modello(modello_var, MODELLO, item, MODELLI, id_prodotto) {
      this.message_ = [item, MODELLI, id_prodotto];
      this.$store.commit("search_id_product_by_modello_var", {
        modello_var: modello_var,
        MODELLO: MODELLO,
      });
    },
  },
};
</script>
<style scoped>
.not_active_image_j {
  opacity: 0.3;
}
.product-list-modello {
  display: flex;
  flex-direction: row;
}
.mdi-chevron-left {
  background: black;
  width: 10px;
  height: 10px;
}
.mdi-chevron-left:before {
  content: "\F0141" !important;
  border: 1px solid red !important;
  color: green;
  width: 10px;
  height: 10px;
}
.mdi-chevron-left:before {
  width: 10px;
  height: 10px;
  content: "\F0141" !important;
}
.margin_negativo_30 {
  margin-top: -30px !important;
}
.not_active_input {
  display: none;
}
.active_input {
  position: absolute;
  left: -11px;
}
input[type="file"] {
  display: none;
}
.custom-file-upload {
  opacity: 0.1;
  display: inline-block;
  cursor: pointer;
}
</style>
<style>
.custom-file-upload.not_active_input {
  display: none !important;
}
.custom-file-upload:hover {
  opacity: 1;
}
</style>
